import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "search",
    "joinedGrid",
    "availableGrid",
    "modal",
    "modalName",
    "modalMembers",
    "tabButton",
    "tab"
  ];

  connect() {}

  filter() {
    const term = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase();

    // Search every community card on the page (joined, available, trending),
    // matching on both name and description. No reliance on specific grid
    // targets, so a missing grid can't throw and silently break search.
    this.element.querySelectorAll('.community-card').forEach((card) => {
      const name = card.querySelector('.community-info h4')?.textContent.toLowerCase() || '';
      const desc = card.querySelector('.community-info p')?.textContent.toLowerCase() || '';
      const matches = term === '' || name.includes(term) || desc.includes(term);
      card.style.display = matches ? '' : 'none';
    });
  }

  join(event) {
    const card = event.currentTarget.closest('.community-card');
    if (!card) return;

    // Move card to joined grid visually
    card.classList.add('joined');
    const badge = document.createElement('span');
    badge.className = 'joined-badge';
    badge.textContent = 'Joined';
    const statusContainer = card.querySelector('.community-status');
    if (statusContainer) {
      statusContainer.prepend(badge);
    } else {
      const info = card.querySelector('.community-info');
      const status = document.createElement('div');
      status.className = 'community-status';
      status.appendChild(badge);
      info?.appendChild(status);
    }

    if (this.hasJoinedGridTarget) {
      this.joinedGridTarget.prepend(card);
    }

    // Feedback toast
    const name = card.querySelector('.community-info h4')?.textContent || 'Community';
    this.showJoinedFeedback(name, card.querySelector('.community-info p')?.textContent || '');
  }

  open(event) {
    event.preventDefault();
    const card = event.currentTarget.closest('.community-card');
    if (!card) return;
    
    // Get community ID from data attribute
    const communityId = card.dataset.communityId;
    if (!communityId) return;

    // Load community details via Turbo Frame
    Turbo.visit(`/dashboard/communities/${communityId}`, { frame: "community_modal" });
  }

  close() {
    if (this.hasModalTarget) this.modalTarget.classList.remove('active');
  }

  showTab(event) {
    const button = event.currentTarget;
    const targetName = button.dataset.tab;
    // buttons
    this.tabButtonTargets.forEach(b => b.classList.remove('active'));
    button.classList.add('active');
    // tabs
    this.tabTargets.forEach(t => t.classList.remove('active'));
    const target = this.element.querySelector(`#community${targetName}`);
    if (target) target.classList.add('active');
  }

  showJoinedFeedback(name, membersText) {
    const feedback = document.createElement('div');
    feedback.style.cssText = `
      position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
      background: white; padding: 2rem; border-radius: 1rem;
      box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1);
      text-align: center; z-index: 9999; animation: slideUp 0.3s ease-out;`;
    feedback.innerHTML = `
      <div style="font-size: 3rem; margin-bottom: 1rem;">🎉</div>
      <h3 style="margin-bottom: .5rem; color: #1f2937;">Joined ${name}!</h3>
      <p style="color: #6b7280; margin-bottom: 0;">${membersText || ''}</p>`;
    document.body.appendChild(feedback);
    setTimeout(() => feedback.remove(), 2000);
  }
}


